module.exports = __webpack_public_path__ + "media/styles/images/svg/comment-gray-f1c3a3824b52b6ed7d64bb562915f5c9.svg";